"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBlank = void 0;
const isBlank = (str) => !str || /^\s*$/.test(str);
exports.isBlank = isBlank;
